import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_SCHEME = {
  text: '#4dff58',
  link: 'hsl(120, 100%, 65%)',
  bgInner: '#444444',
  bgOuter: '#000000'
};

const makeScheme = () => {
  const hue = Math.floor(Math.random() * 360);
  return {
    text: `hsl(${hue}, 100%, 65%)`,
    link: `hsl(${(hue + 180) % 360}, 100%, 65%)`,
    bgInner: `hsl(${hue}, 30%, 27%)`,
    bgOuter: `hsl(${(hue + 40) % 360}, 45%, 5%)`
  };
};

const STORAGE_KEY = 'cyberdeck:session';

const load = () => {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
};

const save = (state) => {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ scheme: state.scheme, overlay: state.overlay })
    );
  } catch {
    // ignore write failures (private mode, quota)
  }
};

const persisted = load();

const sessionSlice = createSlice({
  name: 'session',
  initialState: {
    username: '',
    scheme: persisted.scheme || DEFAULT_SCHEME,
    overlay: persisted.overlay ?? 0.5,
    loadedTitle: ''
  },
  reducers: {
    setUsername: (state, action) => {
      state.username = action.payload;
    },
    setLoadedTitle: (state, action) => {
      state.loadedTitle = action.payload;
    },
    setOverlay: (state, action) => {
      state.overlay = action.payload;
      save(state);
    },
    clearUsername: (state) => {
      state.username = '';
    },
    setScheme: (state, action) => {
      state.scheme = action.payload;
      save(state);
    },
    randomizeScheme: {
      reducer: (state, action) => {
        state.scheme = action.payload;
        save(state);
      },
      prepare: () => ({ payload: makeScheme() })
    }
  }
});

export const {
  setUsername,
  setLoadedTitle,
  clearUsername,
  setScheme,
  randomizeScheme,
  setOverlay
} = sessionSlice.actions;
export { DEFAULT_SCHEME };
export default sessionSlice.reducer;
